<template>
    <ol class="breadcrumb">
        <li class="breadcrumb-item"
            v-for="folder in breadcrumbs"
            v-bind:key="folder.id"
            v-on:click="$emit('folder-selected', folder)"
            v-bind:class="{ active: folder === baseFolder }"
        >
            {{ folder.name }}
        </li>
    </ol>
</template>

<script>
    import CreateFolderBreadcrumbsMixin from '../Mixins/create-folder-breadcrumbs';
    
    export default {
        name: "media-library-breadcrumbs",
        mixins: [CreateFolderBreadcrumbsMixin],
        computed: {
            breadcrumbs(){
                const vm = this;
                
                return vm.createBreadcrumbsForFolder(vm.baseFolder);
            }
        },
        props: {
            baseFolder: Object
        }
    };
</script>
